import { useEffect, useRef, useState } from "react";
import modalStyle from "../modal.module.css";
import formStyle from "../../Forms/form.module.css";

export interface NameModalData {
  submit: (name: string) => void | Promise<void>;
  close: () => void;
  title: string;
  initialValue?: string;
}

function NameModal({ submit, close, title, initialValue = "" }: Readonly<NameModalData>) {
  const dialogRef = useRef<HTMLDialogElement>(null);

  const [content, setContent] = useState<string>(initialValue);

  useEffect(() => {
    const dialog = dialogRef?.current;
    if (dialog) {
      dialog.showModal();
      dialog.addEventListener("close", close);
    }

    return () => {
      if (dialog) {
        dialog.removeEventListener("close", close);
      }
    };
  }, [close]);

  return (
    <dialog ref={dialogRef} className={modalStyle.dialog + " " + modalStyle.modalStyle}>
      <label><h3>{title}</h3></label>
      <input
        className={formStyle.inputField + " " + modalStyle.inputField}
        value={content}
        id="name-input"
        onChange={(e: React.FormEvent<HTMLInputElement>) => {
          setContent(e.currentTarget.value);
        }}
        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
          if (e.key === "Enter") {
            submit(content);
            close();
          }
        }}
      />

      <div className={modalStyle.buttonRow}>
        <button className={modalStyle.cancelButton} onClick={close}>
          Cancel
        </button>
        <button
          className={modalStyle.confirmButton}
          onClick={() => {
            submit(content);
            close();
          }}
        >
          Add
        </button>
      </div>
    </dialog>
  );
}

export default NameModal;
